import { render, staticRenderFns } from "./TwoFASetup.vue?vue&type=template&id=de2f04da"
import script from "./TwoFASetup.vue?vue&type=script&lang=js"
export * from "./TwoFASetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports